<template>
  <div class="myhome-privacy xs-12 m-8 l-9">
    <div class="myhome-privacy__title dea-heading--medium-xxl" tabindex="0">
      {{ user.parent_id ? "Notifiche" : "Privacy e Notifiche" }}
    </div>
    <MyProfileModify
      v-if="false"
      empty-label="Solo comunicazioni necessarie"
      :link-color="user.targetCss.colorMod"
      :options="newsletterOptions"
      title="Newsletter attive"
      @open-modify="openModal('newsletter')"
    />
    <div v-if="false" class="myhome-privacy__blackcat dea-border-grey-medium">
      <div class="myhome-privacy__blackcat-logo">
        <img :src="blackcatLogo" />
      </div>
      <div class="myhome-privacy__blackcat-content ">
        <div class="myhome-privacy__blackcat-content-label dea-heading--regular-s">
          Stai cercando informazioni sulle newsletter Blackcat-Cideb?
        </div>
        <Links
          class="myhome-privacy__blackcat-content-links dea-links--large"
          :class="`dea-links--${user.targetCss.colorMod}`"
          href="https://www.blackcat-cideb.com/it/profile/"
          icon="go-to"
          target="_blank"
        >
          Vai al tuo profilo Blackcat-Cideb
        </Links>
      </div>
    </div>
    <MyProfileModify
      :link-color="user.targetCss.colorMod"
      :options="messagesOptions"
      :show-link="false"
      title="Notifiche attive"
      @open-modify="openModal('messages')"
    />
    <Links
      class="dea-links--large"
      :class="`dea-links--${user.targetCss.colorMod}`"
      icon="go-to"
      type="router-link"
      :to="{ name: 'my-profile-notifications' }"
    >
      Vai all'elenco completo delle notifiche
    </Links>
    <MyProfileModify
      v-if="!user.parent_id"
      empty-label="Hai scelto di non prestare alcun consenso"
      :link-color="user.targetCss.colorMod"
      :options="privacyOptions"
      title="Privacy"
      @open-modify="openModal('privacy')"
    />
    <Modal :visible="modalVisible" @modal-close="modalVisible = false">
      <template slot="title">
        <div>
          {{ privacyPageContent(user.role)[contentType].title }}
        </div>
      </template>
      <template v-if="contentType !== 'privacy'" slot="content">
        <div
          v-if="privacyPageContent(user.role)[contentType].description"
          class="myhome-privacy__modal-description dea-heading--regular-s"
          v-html="printDescription(privacyPageContent(user.role)[contentType].description)"
        ></div>
        <div v-if="contentType === 'messages'" class="myhome-privacy__modal-checkboxes">
          <Checkbox id="essentials" name="essentials" :checked="true" :disabled="true" type="checkbox">
            <span class="dea-heading--regular-xs">Solo notifiche necessarie</span>
            <br />
            <span class="dea-heading--regular-xxs">
              OBBLIGATORIO - Riceverai gli avvisi riguardanti gli aggiornamenti e le modifiche richeiste al tuo profilo
              e le ricevute dei tuoi acquisti.
            </span>
          </Checkbox>
        </div>
        <div
          v-for="(option, idx) in privacyPageContent(user.role)[contentType].options"
          :key="idx"
          class="myhome-privacy__modal-checkboxes"
        >
          <Checkbox
            v-if="option.label"
            :id="option.id"
            :name="option.id"
            :checked="check[option.id]"
            type="checkbox"
            @change="switchCheckbox(option.id)"
          >
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="option.label"></span>
          </Checkbox>
        </div>
        <Buttons class="myhome-privacy__modal-button-save dea-button--large" @click="saveSettings">
          Salva modifiche
        </Buttons>
      </template>
      <template v-else slot="content">
        <div
          class="myhome-privacy__modal-description dea-heading--regular-s"
          v-html="printDescription(privacyPageContent(user.role)[contentType].description)"
        ></div>
        <div class="myhome-privacy__modal-section">
          <div class="myhome-privacy__modal-section-title dea-heading--medium-s">Marketing Diretto</div>
          <div class="myhome-privacy__modal-section-body dea-heading--regular-xs">
            Per la finalità di marketing di cui alla Sezione E, punto (i) dell’Informativa, in virtù dell’articolo 6,
            comma 1, punto f) del Regolamento, il Titolare del Trattamento potrà svolgere tale attività basandosi sul
            suo interesse legittimo, a prescindere dal tuo consenso e comunque sino ad una tua opposizione a tale
            Trattamento come meglio esplicitato nel Considerando 47 del Regolamento nel quale viene “considerato
            legittimo interesse trattare dati personali per finalità di marketing diretto”. A tal proposito, i tuoi Dati
            Personali saranno trattati per informarti su servizi e iniziative promozionali del Titolare del Trattamento,
            anche mediante modalità di contatto di tipo automatizzato o tradizionale. Qualora non volessi ricevere
            comunicazioni per tale finalità ti invitiamo a spuntare la seguente casella
            <Checkbox
              id="cons_promo"
              name="cons_promo"
              :checked="!check['cons_promo']"
              type="checkbox"
              @change="switchCheckbox('cons_promo')"
            >
            </Checkbox>
            opponendoti sin d’ora al trattamento oppure potrai limitare le attività di Trattamento a specifiche modalità
            di contatto comunicandolo al Titolare del Trattamento tramite i canali di contatto di cui all’Informativa.
          </div>
        </div>
        <div class="myhome-privacy__modal-section">
          <div class="myhome-privacy__modal-section-title dea-heading--medium-s">Marketing Indiretto</div>
          <div class="myhome-privacy__modal-section-body dea-heading--regular-xs">
            Per la finalità di marketing indiretto, di cui alla Sezione E, punto (ii) dell’Informativa, i tuoi Dati
            Personali saranno trattati dal Titolare del Trattamento per informarti su servizi e iniziative promozionali
            di soggetti terzi, anche mediante modalità di contatto di tipo automatizzato (e-mail) o tradizionale
            (telefono con operatore, posta), con avvertenza che in qualsiasi momento potrai revocare il consenso anche
            in via parziale, per esempio nei riguardi delle sole modalità di contatto automatizzate.
          </div>
          <div class="myhome-privacy__modal-section-radio">
            <RadioButton
              id="cons_promo3-yes"
              :checked="check['cons_promo3']"
              name="cons_promo3"
              value="yes"
              @click="switchRadio('cons_promo3', true)"
              >rilascio il consenso</RadioButton
            >
            <RadioButton
              id="cons_promo3-no"
              :checked="!check['cons_promo3']"
              name="cons_promo3"
              value="no"
              @click="switchRadio('cons_promo3', false)"
              >nego il consenso</RadioButton
            >
          </div>
        </div>
        <div class="myhome-privacy__modal-section">
          <div class="myhome-privacy__modal-section-title dea-heading--medium-s">Profilazione</div>
          <div class="myhome-privacy__modal-section-body dea-heading--regular-xs">
            Per la finalità di profilazione di cui alla Sezione E, punto (iii) dell’Informativa i tuoi Dati Personali
            saranno trattati dal Titolare del Trattamento per profilarti ossia valutare i tuoi gusti, preferenze ed
            abitudini di consumo anche correlate ad indagini di mercato ed analisi di tipo statistico. Rientra in questa
            categoria qualsiasi forma di Trattamento automatizzato di Dati Personali per valutare determinati aspetti
            personali quali quelli riguardanti, a titolo esemplificativo e non esaustivo, il rendimento professionale,
            la situazione economica, le preferenze personali, gli interessi, l’affidabilità, il comportamento,
            l’ubicazione o gli spostamenti.
          </div>
          <div class="myhome-privacy__modal-section-radio">
            <RadioButton
              id="cons_consumi-yes"
              :checked="check['cons_consumi']"
              name="cons_consumi"
              value="yes"
              @click="switchRadio('cons_consumi', true)"
              >rilascio il consenso</RadioButton
            >
            <RadioButton
              id="cons_consumi-no"
              :checked="!check['cons_consumi']"
              name="cons_consumi"
              value="no"
              @click="switchRadio('cons_consumi', false)"
              >nego il consenso</RadioButton
            >
          </div>
        </div>
        <Buttons class="myhome-privacy__modal-button-save dea-button--large" @click="saveSettings">
          Salva modifiche
        </Buttons>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import Links from "@/components/elements/Links";
import RadioButton from "@/components/elements/RadioButton";
import Modal from "@/components/patterns/Modal";
import MyProfileModify from "../components/MyProfileModify";
import privacyPageContent from "../helpers/privacyPageContent";
import blackcatLogo from "~/assets/blackcat-cideb.png";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfilePrivacy",
  components: { Buttons, Checkbox, Links, MyProfileModify, Modal, RadioButton },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      blackcatLogo,
      check: {
        // FIXME: We lack messages section
        cons_consumi: false,
        cons_consumi_date: "",
        cons_promo: true,
        cons_promo_date: "",
        cons_promo3: false,
        cons_promo3_date: "",
        newsletters_editoriale: false,
        newsletters_formazione: false,
      },
      contentType: "newsletter",
      modalVisible: false,
    };
  },
  computed: {
    messagesOptions() {
      // FIXME: Currently we need to force MyProfileModify for messages to show emptyLabel
      // const optionsArray = this.privacyPageContent(this.user.role).messages.options.filter(opt => {
      //   return this.user[opt.id];
      // });
      // return optionsArray;
      return [];
    },
    newsletterOptions() {
      const optionsArray = this.privacyPageContent(this.user.role).newsletter.options.filter(opt => {
        return this.user[opt.id];
      });
      return optionsArray;
    },
    privacyOptions() {
      const optionsArray = this.privacyPageContent(this.user.role).privacy.options.filter(opt => {
        return this.user[opt.id];
      });
      return optionsArray;
    },
  },
  watch: {
    "check.cons_promo": function(newVal) {
      this.check.newsletters_editoriale = newVal;
    },
  },
  mounted() {
    setFocus("myhome-privacy__title");

    Object.keys(this.check).forEach(key => {
      if (key.includes("_date")) {
        this.check[key] = this.user[key];
      } else {
        this.check[key] = Boolean(this.user[key]);
      }
    });
  },
  activated() {
    setFocus("myhome-privacy__title");
  },
  methods: {
    ...mapActions(["fetchUser", "savePrivacySettings"]),
    printDescription(description) {
      const result = description.replace(
        "%(privacy-link)s",
        `<a class="dea-links--large dea-links--${this.user.targetCss.colorMod}" href="https://digital.mondadori.it/privacy/informativasiti/dscuolainformativapiattaforma.html" target="_blank">
        <span class="dea-links__label">Informativa</span>
      </a>`
      );
      return result;
    },
    setDates() {
      Object.keys(this.check).forEach(key => {
        if (!key.includes("cons_") || key.includes("_date")) {
          return;
        }
        if (this.check[key] === this.user[key]) {
          return;
        }
        const now = new Date();
        this.check[`${key}_date`] = now.toISOString();
      });
    },
    openModal(type) {
      this.contentType = type;
      this.modalVisible = true;
    },
    privacyPageContent,
    async saveSettings() {
      document.querySelector("body").classList.add("wait");
      this.setDates();
      const payload = {
        userId: this.user.id,
        userChanges: this.check,
      };
      await this.savePrivacySettings(payload);
      await this.fetchUser(true);
      document.querySelector("body").classList.remove("wait");
      this.modalVisible = false;
    },
    switchCheckbox(id) {
      this.check[id] = Boolean(!this.check[id]);
    },
    switchRadio(id, value) {
      this.check[id] = value;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-privacy {
  &__content {
    margin-bottom: $space-base;
  }

  &__blackcat {
    @include media("<=m") {
      flex-direction: column;
      justify-content: center;
      padding: $space-base $space-xm-small;
    }

    border: $border-bold;
    border-radius: $border-radius-large;
    display: flex;
    flex-direction: row;
    padding: $space-intermediate $space-base;

    &-logo {
      @include media("<=m") {
        justify-content: center;
        margin-bottom: $space-xm-small;
      }

      align-items: center;
      display: flex;

      img {
        height: $space-s-large;
        width: auto;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      margin: 0 $space-intermediate;

      &-label {
        margin: $space-x-small 0;
      }
    }
  }

  &__link-privacy-page {
    border-bottom: 2px solid;
  }

  &__modal-description {
    margin-bottom: $space-base;
  }

  &__modal-section {
    margin-top: $space-small;

    &-body {
      margin-top: $space-x-small;

      .dea-checkbox {
        display: inline-block;
        margin-left: $space-x-small;
        margin-right: $space-base;
        padding: 0;
        transform: translateY(-3px);
      }
    }

    &-radio {
      margin-top: $space-xm-small;

      .dea-checkbox {
        margin-top: $space-x-small;
        padding-bottom: 0;
      }
    }
  }

  &__modal-checkboxes {
    .dea-checkbox__label {
      max-width: none;
    }
  }

  &__modal-button-save {
    margin: $space-base 0;
  }

  .dea-modal {
    width: 80%;

    &__content {
      @include media("<=m") {
        max-height: 60vh;
        overflow-y: scroll;
      }
    }
  }
}
</style>
